<template>
  <div class="mileage">
    <div class="top fadein">
      <h1>Kilometerstand</h1>
    </div>
    <div class="fadein">
      <button @click="addingMileage = true">Kilometerstand opgeven</button>
    </div>
    <div class="description">
      <p>Geef hier de nieuwe kilometerstand van de auto op.</p>
    </div>
    <div class="fadein">
      <table v-if="mileage.length > 0">
        <thead>
          <th>Datum</th>
          <th>Naam</th>
          <th>KM</th>
        </thead>
        <tbody>
          <tr v-for="mileage, key in filteredMileage" :key="mileage.id">
            <td>{{new Date(mileage.timestamp).toLocaleDateString('nl-NL')}}</td>
            <td>{{mileage.userName}}</td>
            <td>{{mileage.previousMileage}} - {{mileage.mileage}} ({{mileage.mileage - mileage.previousMileage}}km)</td>
            <td><span class="delete" @click="deleteMileage(mileage)" v-if="key === 0">X</span></td>
          </tr>
        </tbody>
      </table>
      <p v-else>Er is nog geen kilometerstand opgegeven.</p>
    </div>
    <add-mileage v-if="addingMileage" @close="addingMileage = false" @update="update"></add-mileage>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode'
import AddMileage from './AddMileage';

export default {
  name: 'Profile',
  components: {
    'add-mileage': AddMileage
  },
  data() {
    return {
      userId: parseInt(jwt_decode(localStorage.getItem('token')).id),
      loading: false,
      mileage: [],
      users: [],
      addingMileage: false
    }
  },
  methods: {
    deleteMileage(mileage) {
      if (confirm('Weet je zeker dat je deze kilometerstand wilt verwijderen?')) {
        const token = localStorage.getItem('token');
        this.loading = true;

        this.axios.delete(this.config.api + '/mileage/' + mileage.id, {
          headers: {
            authorization: token
          }
        })
          .then(result => {
            if (result.data.status) this.getMileage();
            else alert(result.data.message);
          })
          .catch((error) => {
            alert(error.message)
            this.loading = false;
          })
      }
    },
    update() {
      this.getMileage();
    },
    logout() {
      this.global.baseView.logout();
    },
    getMileage() {
      const token = localStorage.getItem('token');
      this.loading = true;
      this.global.GetBaseView().startLoad();

      this.axios.get(this.config.api + '/mileage', {
        headers: {
          authorization: token
        }
      })
        .then(result => {
          this.mileage = result.data;
          this.loading = false;
          this.global.GetBaseView().endLoad();
        })
        .catch(() => {
          this.global.GetBaseView().logout();
          this.global.GetBaseView().endLoad();
          this.loading = false;
        })
    },
    getUser() {
      const token = localStorage.getItem('token');

      this.axios.get(this.config.api + '/users', {
        headers: {
          authorization: token
        }
      })
      .then(result => {
        this.users = result.data;
      })
    }
  },
  computed: {
    filteredMileage: function () {

      return this.mileage.map(mileage => {
        const user = this.users.find(user => user.id === mileage.userId);

        return {
          id: mileage.id,
          timestamp: mileage.timestamp,
          mileage: mileage.mileage,
          previousMileage: mileage.previousMileage,
          userId: mileage.userId,
          userName: user ? `${user.firstname}` : ''
        }
      })
    }
  },
  created() {
    this.getMileage();
    this.getUser();
  },
}
</script>

<style scoped>

.mileage {
  padding: 10px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.options > a {
  margin-left: 10px
}

.field {
  width: 100%;
  padding: 10px 0;

  display: flex;
  justify-content: space-between;
}

.save {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

input {
  width: 60%;
}

.delete {
  color: red;
  font-weight: 900;
}

table {
  font-size: 15px;
}


</style>



// WEBPACK FOOTER //
// src/components/Mileage.vue